import React from 'react';
import { View, Pressable, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';
import Txt from './Txt';

export interface TabItem {
  id: string;
  label: string;
  count?: string | number;
}

interface TabsProps {
  tabs: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
  style?: StyleProp<ViewStyle>;
}

/** RN port of theme.css's .t-tabs / .t-tab — underline-on-active tab bar. */
export default function Tabs({ tabs, activeId, onChange, style }: TabsProps) {
  const t = useTheme();
  return (
    <View style={[{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: t.colors.line }, style]}>
      {tabs.map((tab) => {
        const active = tab.id === activeId;
        return (
          <Pressable
            key={tab.id}
            onPress={() => onChange(tab.id)}
            style={{
              paddingVertical: 9,
              paddingHorizontal: 14,
              borderBottomWidth: 2,
              borderBottomColor: active ? t.colors.ink : 'transparent',
              marginBottom: -1,
              flexDirection: 'row',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <Txt size="md" weight="medium" color={active ? 'ink' : 'ink3'}>{tab.label}</Txt>
            {tab.count !== undefined && (
              <Txt size="xs" mono color="ink3">{tab.count}</Txt>
            )}
          </Pressable>
        );
      })}
    </View>
  );
}
